module.exports = __webpack_public_path__ + "img/shop_header.f8c057ed.png";